import { createUseStyles } from "react-jss";

export default createUseStyles({
    floatingContainer: {
        fontFamily: "Open Sans",
        position: "fixed",
        minWidth: 59,
        minHeight: 59,
        width: ({ open }: { open: boolean }) => (open ? 450 : 59),
        height: ({ open }: { open: boolean }) => (open ? 500 : 59),
        boxSizing: "border-box",
        zIndex: 10,
    },
    toolbar: {
        color: "white",
        position: "absolute",
        top: 0,
        left: 0,
        right: 20,
        touchAction: "none",
    },
    widgetToggleButton: {
        background: "#ff6f00",
        borderRadius: "50%",
        minWidth: 59,
        width: 59,
        height: 59,
        textAlign: "center",
        lineHeight: "59px",
        fontSize: "28px",
        zIndex: 1,
        boxShadow: "0px 3px 28px #00000033",
        position: "relative",
        cursor: "pointer",
        userSelect: "none",
    },
    widgetToggleButtonIcon: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: "auto",
    },
    titleContainer: {
        position: "absolute",
        top: 0,
        left: 35,
        right: 0,
        bottom: 0,
        height: 32,
        display: "flex",
        userSelect: "none",
        margin: "auto",
        background: "#ff6f00",
        borderTopRightRadius: 24,
        borderBottomRightRadius: 24,
        lineHeight: "32px",
        overflow: "hidden",
    },
    title: {
        fontWeight: 700,
        fontSize: 15,
        lineHeight: "30px",
        height: 30,
        margin: 0,
        flex: 1,
        marginLeft: 35,
        marginBottom: 2,
    },
    settingsButton: {
        padding: [[0, 10]],
        cursor: "pointer",

        "& svg": {
            transition: "color 200ms",
            color: ({ selected }: { selected: string }) =>
                selected === "settings" ? "#fff" : "#ffffff99",
        },

        "&:hover svg": {
            color: "#fff",
        },
    },
    panel: {
        position: "absolute",
        top: 61,
        left: 60,
        right: 0,
        bottom: 0,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    panelContainer: {
        position: "absolute",
        top: 20,
        left: 20,
        bottom: 20,
        right: 20,
        background: "#fff",
        boxShadow: "0px 3px 20px #00000029",
        borderRadius: 15,
        boxSizing: "border-box",
        overflow: "hidden",
    },
    panelContent: {
        position: "absolute",
        top: 23,
        left: 23,
        right: 23,
        bottom: 23,
        minWidth: 200,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    panelButtonContainer: {
        margin: [[6, 9]],
        position: "absolute",
        left: 0,
        top: 60,
        zIndex: 3,
    },
    panelButton: {
        margin: [[16, 0]],
        width: 40,
        height: 40,
        textAlign: "center",
        borderRadius: "50%",
        background: "#DFDFDF",
        color: "#616161",
        cursor: "pointer",
        transition: "background 200ms, color 200ms",

        "&:hover": {
            background: "#ccc",
        },
    },
    panelButtonIcon: {
        lineHeight: "40px",
        fontSize: "18px",
    },
    panelButtonActive: {
        background: "#FFA200",
        color: "#fff",
        position: "relative",

        "&:hover": {
            background: "#FFA200",
        },
    },
    panelIndicatorShadow: {
        content: "",
        display: "block",
        position: "absolute",
        left: 0,
        marginTop: -8,
        marginLeft: -20,
        borderTopWidth: 11,
        borderBottomWidth: 11,
        transition: "top 200ms",
        border: "20px solid transparent",
        borderRightColor: "#00000008",
    },
    panelIndicator: {
        content: "",
        display: "block",
        position: "absolute",
        left: 0,
        marginTop: -9,
        marginLeft: -18,
        borderTopWidth: 10,
        borderBottomWidth: 10,
        transition: "top 200ms",
        border: "19px solid transparent",
        borderRightColor: "white",
        zIndex: 2,
    },
});
